import React, { useMemo } from "react";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function ScorePlusActivityChart({ records = [] }) {
  const chartData = useMemo(() => {
    const activities = {};

    records.forEach((record) => {
      const activity = record.act || "Others";

      activities[activity] = (activities[activity] || 0) + 1;
    });

    const labels = Object.keys(activities);

    const values = labels.map((label) => activities[label]);

    return {
      labels,

      datasets: [
        {
          data: values,

          backgroundColor: [
            "#06b6d4",
            "#10b981",
            "#f59e0b",
            "#ef4444",
            "#8b5cf6",
            "#ec4899",
            "#3b82f6",
            "#84cc16",
            "#14b8a6",
            "#f97316",
            "#6366f1",
            "#64748b",
          ],

          borderWidth: 1,

          borderColor: "#111827",
        },
      ],
    };
  }, [records]);

  const options = {
    responsive: true,

    maintainAspectRatio: false,

    plugins: {
      legend: {
        position: "right",

        labels: {
          color: "#ffffff",

          padding: 18,

          font: {
            size: 12,
          },
        },
      },
    },
  };

  return (
    <div className="bg-gray-900 border border-gray-700 rounded-xl p-5">
      <div className="text-lg font-semibold text-white mb-4">
        Activity Distribution
      </div>

      <div className="h-80">
        <Doughnut data={chartData} options={options} />
      </div>
    </div>
  );
}
